import { __awaiter } from "tslib";
import { selectIsApiProxySupported } from '@reducers/settings/selectors';
import { store } from '@reducers/store';
import { hasThirdPartyCookies } from '@utils/privacy';
import _ from 'lodash';
import { messaging } from '../lib/messaging';
import apiClient, { getApiHeaders } from './apiClient';
/**
 * POST to the search API (`apiClient` base URL).
 * When 3rd party cookies are blocked, the request is sent through the core plugin service worker (plugin v11.1.0+),
 * otherwise it goes directly with `apiClient`.
 */
export function postWithProxy(route, data) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        const isThirdPartyCookiesEnabled = yield hasThirdPartyCookies();
        const isApiProxySupported = selectIsApiProxySupported(store.getState());
        if (isThirdPartyCookiesEnabled || !isApiProxySupported) {
            const response = yield apiClient.post(route, data, { headers: getApiHeaders() });
            return response.data;
        }
        const response = yield messaging.request({
            url: `${apiClient.defaults.baseURL}${route}`,
            method: 'POST',
            data,
            headers: _.omitBy(getApiHeaders(), _.isNil),
        });
        if (!response.status || response.status < 200 || response.status >= 300) {
            const error = _.isPlainObject(response.error) ? response.error : { message: response.error };
            // same fields as ApiError from ajaxUtils
            throw Object.assign(new Error(error.message || 'API Error'), error, {
                code: (_a = error.code) !== null && _a !== void 0 ? _a : response.status,
                httpStatus: response.status,
            });
        }
        return response.data;
    });
}
